export default __webpack_public_path__ + "static/media/aerobite.192f281a.webp";